module.exports = __webpack_public_path__ + "static/media/frog.e13b9fc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/frog.mp3
// module id = lYHC
// module chunks = 1 3